import LocalSettingsProto from "../../core/gd/settings/local-settings/local-settings-v4";

export default class HomeLocalSettings extends LocalSettingsProto {

    public weekView             : any       = gd.const.myWork.viewType.ACTION_REQUIRED
    public displayItemsTypes    : any[]       = []
    public inboxGroupByDay      : boolean       = false

    constructor() {
        super(gd.companyId + '.my-work')   // ! yes each company has their own settings

        const lsValues          = this._readFromLocalStorage();

        this.weekView               = _.get(lsValues, 'weekView', gd.const.myWork.viewType.ACTION_REQUIRED)
        this.inboxGroupByDay        = _.get(lsValues, 'inboxGroupByDay', false)

        this.displayItemsTypes      = _.get(lsValues, 'displayItemsTypes', [
            gd.const.myWork.resourceType.ACTION_REQUIRED_TASK,
            gd.const.myWork.resourceType.ASSIGNED_TO_TASK,
            gd.const.myWork.resourceType.DEADLINE,
            gd.const.myWork.resourceType.MILESTONE,
            gd.const.myWork.resourceType.PERSONAL_EVENT,
            gd.const.myWork.resourceType.MEETING,
            gd.const.myWork.resourceType.REMINDER,
            gd.const.myWork.resourceType.REPORT,
            gd.const.myWork.resourceType.MENTION,
        ]);

    }

    toObject() {
        return {
            weekView            : this.weekView,
            displayItemsTypes   : this.displayItemsTypes,
            inboxGroupByDay     : this.inboxGroupByDay,
        };
    }
}
